import { BonusByProductCardsTranslations } from ".";

export const BONUS_BY_PRODUCT_CARDS_FR_FR: BonusByProductCardsTranslations = {
	totalProductsValue: "Bonification totale en produits",
	totalTipValue: "Bonification totale en propin",
	totalValue: "Total",
	receivedInPeriod: "Reçu dans l'événement",
	receivedAtAnotherPeriod: "Reçu dans d'autres événements",
};
